import { Fragment, useEffect, useRef, useState } from 'react'

import { useResizeDetector } from 'react-resize-detector'

import { Arrow, Pagination } from '@egjs/flicking-plugins'
import Flicking, { ViewportSlot } from '@egjs/react-flicking'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import List from 'Root/App/Tag/List'
import Title from 'Root/App/Title'
import delay from 'lodash/delay'
import filter from 'lodash/filter'
import join from 'lodash/join'
import map from 'lodash/map'
import size from 'lodash/size'

import styles from './index.module.css'

const Carousel = ({ content }) => {
  const [plugins, setPlugins] = useState([])
  const [index, setIndex] = useState(0)
  const { width, ref } = useResizeDetector()
  const flicking = useRef(null)

  const filtered = filter([content.label, `${index + 1}/${size(content.urls)}`])

  useEffect(() => {
    if (!Boolean(flicking?.current)) {
      return
    }

    const arrow = new Arrow()
    const pagination = new Pagination({
      bulletCount: 7,
      parentEl: document.querySelector(`*[data-card-id="${content.id}"]`),
      selector: `#flicking-pagination-${content.id}`,
      type: 'scroll',
    })
    setPlugins([arrow, pagination])

    flicking.current.on('ready', () => {
      delay(() => {
        arrow.init(flicking.current)
        pagination.init(flicking.current)
      }, 50)
    })
  }, [flicking, width, content.id])

  return (
    <Fragment>
      <div className="w-full" ref={ref}>
        <Flicking
          align="center"
          autoResize
          bounce="100%"
          className={styles.cover}
          hideBeforeInit
          key={content.id}
          moveType="strict"
          noPanelStyleOverride
          onChanged={({ index }) => setIndex(index)}
          plugins={plugins}
          ref={flicking}
          resizeOnContentsReady
          useResizeObserver
        >
          {map(content.urls, (url) => (
            <img
              alt={content.title}
              className={styles.carouselImage}
              key={url}
              src={url}
              width={width}
            />
          ))}
          <ViewportSlot>
            <span className="item-inside-viewport"></span>
            <span className="flicking-arrow-prev"></span>
            <span className="flicking-arrow-next"></span>
          </ViewportSlot>
        </Flicking>
      </div>
      <div
        id={`flicking-pagination-${content.id}`}
        className={styles.pagination}
      ></div>
      <div className="flex flex-col gap-y-3 p-6">
        <div className="flex flex-col gap-y-3">
          <PreTitle>{join(filtered, ' · ')}</PreTitle>
          <Title maxRows={3}>{content.title}</Title>
          <Paragraph>{content.description}</Paragraph>
        </div>
        <List tags={content.tags} />
      </div>
    </Fragment>
  )
}

export default Carousel
